import { AuditRecord } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { AUDIT_RESULT } from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'
import palette from 'src/designSystem/variables/palette'
import { EvidenceControlsListItemMenuProxy } from './EvidenceControlsListItemMenuProxy'

export type ControlsListItemProps = {
  controlModelId: string
  audit?: AuditRecord
  config?: ControlListItemConfig
  linkedPolicyNames?: string[]
  linkedDepartmentNames?: string[]
}

export enum ControlListItemConfig {
  DEFAULT = 'default',
  AI_DASHBOARD = 'ai-dashboard',
  EVIDENCE = 'evidence',
  EVIDENCE_VIA_REQUEST = 'evidence-via-request',
  FRAMEWORK_REQUIREMENT = 'framework-requirement',
}

export type ControlListItemConfigMap = {
  showDepartmentColumn: boolean
  showModelIdColumn: boolean
  showControlNameColumn: boolean
  showFrameworkColumn: boolean
  showCPMDColumn: boolean
  showOperatingEffectivenessColumn: boolean
  showLinkedEvidenceColumn: boolean
  showStatusColumn: boolean
  showAssigneeColumn: boolean
  showMenuColumn: boolean
  customMenu?: ({
    control,
  }: {
    control: Control.AsObject
  }) => JSX.Element | null
  customNameSuffix?: string
}

export const ControlListItemConfigurations: Record<
  ControlListItemConfig,
  ControlListItemConfigMap
> = {
  [ControlListItemConfig.DEFAULT]: {
    showDepartmentColumn: true,
    showModelIdColumn: true,
    showControlNameColumn: true,
    showFrameworkColumn: true,
    showCPMDColumn: false,
    showOperatingEffectivenessColumn: true,
    showLinkedEvidenceColumn: true,
    showStatusColumn: true,
    showAssigneeColumn: true,
    showMenuColumn: true,
  },
  [ControlListItemConfig.AI_DASHBOARD]: {
    showDepartmentColumn: true,
    showModelIdColumn: true,
    showControlNameColumn: true,
    showFrameworkColumn: false,
    showCPMDColumn: true,
    showOperatingEffectivenessColumn: true,
    showLinkedEvidenceColumn: false,
    showStatusColumn: false,
    showAssigneeColumn: false,
    showMenuColumn: false,
  },
  [ControlListItemConfig.EVIDENCE]: {
    showDepartmentColumn: true,
    showModelIdColumn: true,
    showControlNameColumn: true,
    showFrameworkColumn: true,
    showCPMDColumn: false,
    showOperatingEffectivenessColumn: true,
    showLinkedEvidenceColumn: true,
    showStatusColumn: true,
    showAssigneeColumn: true,
    showMenuColumn: true,
    customMenu: EvidenceControlsListItemMenuProxy,
  },
  [ControlListItemConfig.EVIDENCE_VIA_REQUEST]: {
    showDepartmentColumn: true,
    showModelIdColumn: true,
    showControlNameColumn: true,
    showFrameworkColumn: true,
    showCPMDColumn: false,
    showOperatingEffectivenessColumn: true,
    showLinkedEvidenceColumn: true,
    showStatusColumn: true,
    showAssigneeColumn: true,
    showMenuColumn: true,
    customMenu: () => null,
    customNameSuffix: '- via request',
  },
  [ControlListItemConfig.FRAMEWORK_REQUIREMENT]: {
    showDepartmentColumn: true,
    showModelIdColumn: true,
    showControlNameColumn: true,
    showFrameworkColumn: false,
    showCPMDColumn: false,
    showOperatingEffectivenessColumn: true,
    showLinkedEvidenceColumn: true,
    showStatusColumn: true,
    showAssigneeColumn: true,
    showMenuColumn: true,
  },
}

export const CONTROL_CHECK_RESULT_PILL_COLOR: Record<AUDIT_RESULT, string> = {
  [AUDIT_RESULT.PASS]: '#45B786',
  [AUDIT_RESULT.FAIL]: '#F87682',
  [AUDIT_RESULT.NOT_RUN]: '#4C5E6E',
  [AUDIT_RESULT.NOT_APPLICABLE]: '#4C5E6E',
  [AUDIT_RESULT.LAMBDA_ERROR]: palette.orange['700'],
  [AUDIT_RESULT.UNKNOWN]: palette.orange['700'],
  [AUDIT_RESULT.MISSING_SUGGESTIONS]: '#4C5E6E',
}
